import styled from "styled-components";
import { Field } from "redux-form/immutable";
import { useIntl } from "react-intl";

import { selectBox } from "../../select-box";
import { renderField } from "../../up-input";
import messages from "../messages";
import {
  getOptions,
  type ConditionFilterProps,
  type ConditionOperator
} from "../utils";
import { positiveInteger } from "../../../utils/validation";

const Filter = styled.div`
  display: flex;
  width: 100%;
  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
`;

const Row = styled.div`
  margin-bottom: 0px;
  width: 100%;
  @media only screen and (max-width: 700px) {
    margin-bottom: 10px;
  }
  @media only screen and (max-width: 550px) {
    margin-bottom: 0px;
  }
`;

const defaultOptions = [
  "smaller-or-equals",
  "greater-or-equals"
] satisfies readonly ConditionOperator[];

const NumberOfVisits = ({ member }: ConditionFilterProps) => {
  const intl = useIntl();

  return (
    <Filter>
      <Row>
        <Field
          name={`${member}.filter.operator`}
          component={selectBox}
          customProps={{
            options: getOptions([], defaultOptions).map(
              ({ value, label }) => ({
                value,
                label: intl.formatMessage(label),
              }),
            ),
            margin: '0 10px 0 0',
            minWidth: '200px',
          }}
        />
      </Row>
      <Field
        name={`${member}.filter.attribute`}
        component={renderField}
        type="number"
        placeholder={intl.formatMessage(messages.value)}
        parse={(value: string) => (value ? parseInt(value, 10) : value)}
        validate={[positiveInteger]}
      />
    </Filter>
  );
};

export default NumberOfVisits;
